"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.object = exports.image = exports.StartPageIcon = exports.SocialIconWrapper = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _colors = require("../style/colors");
var _fonts = require("../style/fonts");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getImageCss = _ref => {
  let {
    size,
    type = 'default'
  } = _ref;
  return (0, _styledComponents.css)(["width:", "px;height:", "px;border-radius:100%;-webkit-mask-size:cover;", " background:url(", ") center no-repeat,url(", ") center no-repeat;background-size:", "px;"], size, size, type === 'social' && `-webkit-mask-image: url(https://static.buffer.com/ui/avatar-mask-${size}.svg);`, props => props.src, props => props.fallbackUrl, size);
};
const image = exports.image = {
  default: {
    xsmall: getImageCss({
      size: 24
    }),
    small: getImageCss({
      size: 32
    }),
    medium: getImageCss({
      size: 40
    }),
    large: getImageCss({
      size: 48
    })
  },
  social: {
    xsmall: getImageCss({
      size: 24,
      type: 'social'
    }),
    small: getImageCss({
      size: 32,
      type: 'social'
    }),
    medium: getImageCss({
      size: 40,
      type: 'social'
    }),
    large: getImageCss({
      size: 48,
      type: 'social'
    })
  }
};
const getWrapperCss = _ref2 => {
  let {
    size
  } = _ref2;
  return (0, _styledComponents.css)(["position:relative;width:", "px;height:", "px;"], size, size);
};
const wrapper = exports.wrapper = {
  xsmall: getWrapperCss({
    size: 24
  }),
  small: getWrapperCss({
    size: 32
  }),
  medium: getWrapperCss({
    size: 40
  }),
  large: getWrapperCss({
    size: 48
  })
};
const getObjectCss = _ref3 => {
  let {
    size
  } = _ref3;
  return (0, _styledComponents.css)(["border-radius:100%;width:", "px;height:", "px;"], size, size);
};
const object = exports.object = {
  xsmall: getObjectCss({
    size: 24
  }),
  small: getObjectCss({
    size: 32
  }),
  medium: getObjectCss({
    size: 40
  }),
  large: getObjectCss({
    size: 48
  })
};
const SocialIconWrapper = exports.SocialIconWrapper = /*#__PURE__*/_styledComponents.default.div.withConfig({
  displayName: "style__SocialIconWrapper",
  componentId: "bufferapp-ui__sc-l1xez3-0"
})(["position:absolute;bottom:0;right:0;width:16px;height:16px;border-radius:100%;background:", ";display:flex;justify-content:center;align-items:center;transform:", ";border:", ";"], props => props.bgColor ? props.bgColor : '#777', props => {
  if (props.size === 'small') {
    return 'translateX(8px) translateY(0px)';
  } else if (props.size === 'xsmall') {
    return 'translateX(8px) translateY(2px)';
  } else {
    return 'translateX(8px) translateY(-2px)';
  }
}, props => {
  if (props.size === 'xsmall') {
    return `1px solid ${_colors.white}`;
  }
  return 'none';
});
const StartPageIcon = exports.StartPageIcon = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "style__StartPageIcon",
  componentId: "bufferapp-ui__sc-l1xez3-1"
})(["color:", ";font-size:9px;font-weight:", ";text-align:center;width:16px;font-family:", ";"], _colors.yellowDarker, _fonts.fontWeightBold, _fonts.fontFamily);